import React from 'react';
import { string } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { StringConstantsMixin } from '../../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import Button from '../../../../../components/shared/Button';
import { submitFacebookTokenToBelay } from '../../../ducks/belay';

const {
  strings: {
    COMMUNITY: {
      CONNECT: { CONNECT }
    }
  }
} = StringConstantsMixin;

const BelayFacebookButton = ({ buttonClassName = '' }) => {
  const {
    facebook: { appId }
  } = useSelector(state => state.belay);
  const dispatch = useDispatch();

  const handleFacebookResponse = response => {
    if (!response.accessToken) {
      console.error('handleFacebookResponse-Community', response);
      return;
    }

    dispatch(submitFacebookTokenToBelay(response.accessToken));
  };

  return (
    <FacebookLogin
      disableMobileRedirect
      appId={appId}
      autoLoad
      callback={handleFacebookResponse}
      scope="user_friends"
      render={renderProps => (
        <Button onClick={renderProps.onClick} variant="primary" classes={buttonClassName}>
          {CONNECT}
        </Button>
      )}
    />
  );
};

BelayFacebookButton.propTypes = {
  buttonClassName: string
};

BelayFacebookButton.defaultProps = {
  buttonClassName: ''
};

export default BelayFacebookButton;
